import { useFormDataQuery } from '@/api/getters';
import { TYPE_OF_DAMAGE } from '@/api/types';
import { FullAC } from '@/features/v2/vehicle-damage/complementaryInformation/survey/FullAC';
import { FullOC } from '@/features/v2/vehicle-damage/complementaryInformation/survey/FullOC';
import { PartAC } from '@/features/v2/vehicle-damage/complementaryInformation/survey/PartAC';
import { PartOC } from '@/features/v2/vehicle-damage/complementaryInformation/survey/PartOC';

export const SurveyComplementary = () => {
  const { data } = useFormDataQuery();

  const typeOfDamage = data?.offer.type_of_damage ?? TYPE_OF_DAMAGE.PART_AC;

  return (
    <>
      {typeOfDamage === TYPE_OF_DAMAGE.PART_OC && <PartOC />}
      {typeOfDamage === TYPE_OF_DAMAGE.FULL_OC && <FullOC />}
      {typeOfDamage === TYPE_OF_DAMAGE.PART_AC && <PartAC />}
      {typeOfDamage === TYPE_OF_DAMAGE.FULL_AC && <FullAC />}
    </>
  );
};
